import { useEffect } from 'react'
import type { AgentRefreshEditorWidget } from 'aevocam-rest-api-spec'

type Props = {
  widget: AgentRefreshEditorWidget
  fromStream?: boolean
  onRefreshEditor?: () => void
}

export function AgentRefreshEditor({
  fromStream,
  onRefreshEditor,
}: Props) {

  //--------------------------------------------------------------------------------
  useEffect(() => {
    if (!fromStream) return
    onRefreshEditor?.()
  }, [fromStream]) // Schedule an immediate(ish) refresh of the article contents

  //--------------------------------------------------------------------------------
  return null
}
